<template>
  <div class="w-full flex flex-col flex-grow p-1">
    <div v-if="Array.isArray(services) && services.length > 0" class="w-full flex flex-col flex-grow">
        <div class="w-full">
            <div class="w-full flex items-center bg-sky flex-wrap">
                <div class="flex-grow truncate flex p-1">
                    <div class="w-full whitespace-normal truncate text-left font-semibold">Total</div>
                </div>
                <div class="w-auto flex flex-wrap">
                    <div class="w-auto py-1 px-2">
                        {{`Hrs: ${isNaN(serviceTotals.hours) ? 0 : serviceTotals.hours}`}}
                    </div>
                    <div class="w-auto py-1 px-2">
                        {{`Revenue: ${isNaN(serviceTotals.revenue) ? '$0' : showAsUSCurrency(serviceTotals.revenue)}`}}
                    </div>
                </div>
            </div>
        </div>
        <div class="w-full flex flex-col flex-auto h-0 flex-grow overflow-y-auto">
            <div v-for="(service, index) in servicesSummary" :key="service.localId ?? service._id ?? index" class="w-full">
                <div class="w-full flex items-center flex-nowrap truncate">
                    <div
                      class="w-full flex items-center py-1 border-b truncate flex-wrap rounded-sm"
                      :class="serviceRowHighlightClass(service)"
                    >
                        <div class="w-44 min-w-44 text-left whitespace-normal truncate p-1">{{ capitalizeString(service.partNumber) }}</div>
                        <div class="flex-grow flex flex-row items-center truncate flex-wrap">
                            <div class="flex-grow p-1 flex items-center">
                                <input v-model.trim="service.description" type="text" class="w-full max-w-md min-w-60" maxlength="100">
                            </div>
                            <div class="w-auto flex items-center flex-wrap p-1">
                                <div class="py-1 flex flex-row space-x-2 items-center pr-2">
                                    <input
                                      v-model="service.hours"
                                      v-hoursInput
                                      type="number"
                                      class="w-20 text-center truncate"
                                      :class="{ 'text-red': isHoursNegative(service) }"
                                      min="-1000000"
                                      max="1000000"
                                      step=".25"
                                    >
                                    <div>qty / hrs.</div>
                                </div>
                                <div class="w-auto py-1 flex flex-row space-x-2 items-center truncate pl-2">
                                    <div>$</div>
                                    <input
                                      v-model="service.revenue"
                                      v-currency
                                      type="text"
                                      class="text-right w-32 truncate"
                                      :class="{ 'text-red': isRevenueNegative(service) }"
                                      min="-10000000000"
                                      max="10000000000"
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="p-1">
                        <ButtonWithConfirm :popperContent="'delete item'" isDelete @confirmed="deleteServiceItem(service.localId)" />
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import {showAsUSCurrency,openDetails,naturalSort,capitalizeString} from '@/shared'
import {TrashIcon} from '@heroicons/vue/solid'
import ButtonWithConfirm from '@/components/ui/ButtonWithConfirm.vue'
import hoursInput from '@/components/ui/directives/hoursInput'
import currency from '@/components/ui/currency'
export default {
    directives:{
        hoursInput,
        currency
    },
    props:{
        services:{type:Array,default:()=>{return []}},
        creditDocumentOptions:{type:Array,default:()=>['contract']},
        highlightInvalidLines:{type:Boolean,default:false},
        isServiceLineValid:{type:Function,default:null}
    },
    components:{ButtonWithConfirm},
    emits:['deleteItem'],
    setup (props,{emit}) {

    const servicesSummary = computed(()=>{
        return naturalSort(props.services,'partNumber','description')
    })

    const serviceTotals = computed(() => {
        if (!Array.isArray(props.services) || props.services.length === 0) {
            return { hours: 0, revenue: 0 };
        }

        let totals = { hours: 0, revenue: 0 };

        for (const service of props.services) {
            // Skip invalid entries
            if (typeof service !== 'object' || service === null) {
                continue;
            }

            const hoursRaw = parseFloat(String(service.hours ?? '').replace(/[^0-9.-]/g, ''))
            const hours = Number.isFinite(hoursRaw) ? hoursRaw : 0
            const revenueRaw = parseFloat(String(service.revenue ?? '').replace(/[^0-9.-]/g, ''))
            const revenue = Number.isFinite(revenueRaw) ? revenueRaw : 0

            totals.hours += hours;
            totals.revenue += revenue;
        }

        return totals;
    });

    const deleteServiceItem = (event)=>{
        emit('deleteItem',event)
    }

    const serviceRowHighlightClass = (service) => {
        if (!props.highlightInvalidLines || typeof props.isServiceLineValid !== 'function') return ''
        if (props.isServiceLineValid(service)) return ''
        return 'bg-red-500 bg-opacity-10 border-l-4 border-l-red-600 pl-1 -ml-0.5'
    }

    const isHoursNegative = (service) => {
        const str = String(service?.hours ?? '').replace(/[^0-9.-]/g, '')
        if (str === '' || str === '-') return false
        const n = parseFloat(str)
        return Number.isFinite(n) && n < 0
    }

    const isRevenueNegative = (service) => {
        const str = String(service?.revenue ?? '')
            .replace(/,/g, '')
            .replace(/[^0-9.-]/g, '')
        if (str === '' || str === '-') return false
        const n = parseFloat(str)
        return Number.isFinite(n) && n < 0
    }

        return {
            capitalizeString,
            showAsUSCurrency,
            openDetails,
            TrashIcon,
            deleteServiceItem,
            servicesSummary,
            serviceTotals,
            serviceRowHighlightClass,
            isHoursNegative,
            isRevenueNegative
        }
    }

}
</script>

<style>

</style>